const VALUTA_REGEX = /^-?[0-9]+(\.[0-9]{1,2})?$/;
export default VALUTA_REGEX;
